import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-common-expand-layout',
  templateUrl: './common-expand-layout.component.html',
  styleUrls: ['./common-expand-layout.component.scss'],
})
export class CommonExpandLayoutComponent implements OnInit {
  @Input() title: string = '';
  @Input() tabs?: any;
  @Input() expand: boolean = true;
  @Output() tabChanged: EventEmitter<string> = new EventEmitter();
  constructor() {}
  
  tabClickHandler(selectedTab: string) {
    this.tabs.forEach((tabObj: any) => {
      selectedTab == tabObj.name
        ? (tabObj.active = true)
        : (tabObj.active = false);
    });
    this.tabChanged.emit(selectedTab);
  }

  ngOnInit(): void {
  }
}
